var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "justify-content": "space-around" } },
    [
      _c(
        "el-checkbox",
        {
          staticStyle: { margin: "0" },
          attrs: { disabled: _vm.disabled },
          on: {
            change: function($event) {
              return _vm.onChange("mblOnly")
            }
          },
          model: {
            value: _vm.job.mblOnly,
            callback: function($$v) {
              _vm.$set(_vm.job, "mblOnly", $$v)
            },
            expression: "job.mblOnly"
          }
        },
        [_vm._v(_vm._s(_vm.$t("SeaExport.DirectBusiness")) + " ")]
      ),
      _c(
        "el-checkbox",
        {
          staticStyle: { margin: "0", "padding-left": "5px" },
          attrs: { disabled: _vm.disabled },
          on: {
            change: function($event) {
              return _vm.onChange("transfering")
            }
          },
          model: {
            value: _vm.job.transfering,
            callback: function($$v) {
              _vm.$set(_vm.job, "transfering", $$v)
            },
            expression: "job.transfering"
          }
        },
        [_vm._v(_vm._s(_vm.$t("SeaExport.Transport")) + " ")]
      ),
      _c(
        "el-checkbox",
        {
          staticStyle: { margin: "0", "padding-left": "5px" },
          attrs: { disabled: _vm.disabled },
          on: {
            change: function($event) {
              return _vm.onChange("batch")
            }
          },
          model: {
            value: _vm.job.batch,
            callback: function($$v) {
              _vm.$set(_vm.job, "batch", $$v)
            },
            expression: "job.batch"
          }
        },
        [_vm._v(_vm._s(_vm.$t("SeaExport.InBatches")) + " ")]
      ),
      _c(
        "el-checkbox",
        {
          staticStyle: { margin: "0", "padding-left": "5px" },
          attrs: { disabled: _vm.disabled },
          on: {
            change: function($event) {
              return _vm.onChange("salePrice")
            }
          },
          model: {
            value: _vm.job.salePrice,
            callback: function($$v) {
              _vm.$set(_vm.job, "salePrice", $$v)
            },
            expression: "job.salePrice"
          }
        },
        [_vm._v(_vm._s(_vm.$t("SeaExport.SpecialPrice")))]
      ),
      _c(
        "el-checkbox",
        {
          staticStyle: { margin: "0", "padding-left": "5px" },
          attrs: { disabled: _vm.disabled },
          on: {
            change: function($event) {
              return _vm.onChange("allocation")
            }
          },
          model: {
            value: _vm.job.allocation,
            callback: function($$v) {
              _vm.$set(_vm.job, "allocation", $$v)
            },
            expression: "job.allocation"
          }
        },
        [_vm._v(_vm._s("Allocation") + " ")]
      ),
      _c(
        "el-checkbox",
        {
          staticStyle: { "padding-left": "5px" },
          attrs: { disabled: _vm.disabled },
          on: {
            change: function($event) {
              return _vm.onChange("availableCabinSpace")
            }
          },
          model: {
            value: _vm.job.availableCabinSpace,
            callback: function($$v) {
              _vm.$set(_vm.job, "availableCabinSpace", $$v)
            },
            expression: "job.availableCabinSpace"
          }
        },
        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AvailableCabinSpace")) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }